import clone from 'lodash-es/clone';
import eq from 'lodash-es/eq';
import isUndefined from 'lodash-es/isUndefined';
export class LinkedList {
    firstNode = null;
    lastNode = null;
    nElements = 0;
    constructor() {
    }
    add(item, index) {
        if (isUndefined(index)) {
            index = this.nElements;
        }
        if (index < 0 || index > this.nElements || isUndefined(item)) {
            return false;
        }
        const newNode = this.createNode(item);
        if (this.nElements === 0) {
            this.firstNode = newNode;
            this.lastNode = newNode;
        }
        else if (index === this.nElements) {
            if (this.lastNode) {
                this.lastNode.next = newNode;
            }
            this.lastNode = newNode;
        }
        else if (index === 0) {
            newNode.next = this.firstNode;
            this.firstNode = newNode;
        }
        else {
            const prev = this.nodeAtIndex(index - 1);
            if (prev) {
                newNode.next = prev.next;
                prev.next = newNode;
            }
            else {
                return false;
            }
        }
        this.nElements++;
        return true;
    }
    get first() {
        if (this.firstNode !== null) {
            return this.firstNode.element;
        }
        return undefined;
    }
    get last() {
        if (this.lastNode !== null) {
            return this.lastNode.element;
        }
        return undefined;
    }
    elementAtIndex(index) {
        const node = this.nodeAtIndex(index);
        if (node === null) {
            return undefined;
        }
        return node.element;
    }
    indexOf(item, equalsFunction) {
        const equalsF = equalsFunction || eq;
        if (isUndefined(item)) {
            return -1;
        }
        let currentNode = this.firstNode;
        let index = 0;
        while (currentNode !== null) {
            if (equalsF(currentNode.element, item)) {
                return index;
            }
            index++;
            currentNode = currentNode.next;
        }
        return -1;
    }
    contains(item, equalsFunction) {
        return this.indexOf(item, equalsFunction) >= 0;
    }
    remove(item, equalsFunction) {
        const equalsF = equalsFunction || eq;
        if (this.nElements < 1 || isUndefined(item)) {
            return false;
        }
        let previous = null;
        let currentNode = this.firstNode;
        while (currentNode !== null) {
            if (equalsF(currentNode.element, item)) {
                if (currentNode === this.firstNode) {
                    this.firstNode = this.firstNode.next;
                    if (currentNode === this.lastNode) {
                        this.lastNode = null;
                    }
                }
                else if (currentNode === this.lastNode) {
                    this.lastNode = previous;
                    if (previous) {
                        previous.next = currentNode.next;
                    }
                    currentNode.next = null;
                }
                else {
                    if (previous) {
                        previous.next = currentNode.next;
                    }
                    currentNode.next = null;
                }
                this.nElements--;
                return true;
            }
            previous = currentNode;
            currentNode = currentNode.next;
        }
        return false;
    }
    clear() {
        this.firstNode = null;
        this.lastNode = null;
        this.nElements = 0;
    }
    equals(other, equalsFunction) {
        const eqF = equalsFunction || eq;
        if (this.size() !== other.size()) {
            return false;
        }
        return this.equalsAux(this.firstNode, other.firstNode, eqF);
    }
    removeElementAtIndex(index) {
        if (index < 0 || index >= this.nElements || this.nElements === 0) {
            return undefined;
        }
        let element;
        if (this.nElements === 1 && this.firstNode) {
            element = this.firstNode.element;
            this.firstNode = null;
            this.lastNode = null;
        }
        else {
            const previous = this.nodeAtIndex(index - 1);
            if (previous === null && this.firstNode) {
                element = this.firstNode.element;
                this.firstNode = this.firstNode.next;
            }
            else if (previous && previous.next === this.lastNode && this.lastNode) {
                element = this.lastNode.element;
                this.lastNode = previous;
                previous.next = null;
            }
            else if (previous !== null) {
                element = (previous.next && previous.next.element) || undefined;
                previous.next = (previous.next && previous.next.next) || null;
            }
        }
        this.nElements--;
        return element;
    }
    forEach(callback) {
        let currentNode = this.firstNode;
        while (currentNode !== null) {
            if (callback(currentNode.element) === false) {
                break;
            }
            currentNode = currentNode.next;
        }
    }
    reverse() {
        let previous = null;
        let current = this.firstNode;
        let temp = null;
        while (current !== null) {
            temp = current.next;
            current.next = previous;
            previous = current;
            current = temp;
        }
        const { firstNode, lastNode } = this;
        this.firstNode = lastNode;
        this.lastNode = firstNode;
    }
    toArray() {
        const array = [];
        let currentNode = this.firstNode;
        while (currentNode !== null) {
            array.push(currentNode.element);
            currentNode = currentNode.next;
        }
        return array;
    }
    map(callback) {
        let currentNode = this.firstNode;
        let index = 0;
        const result = new LinkedList();
        while (currentNode !== null) {
            result.add(callback(clone(currentNode.element), index));
            ++index;
            currentNode = currentNode.next;
        }
        return result;
    }
    slice(begin, end) {
        const startIndex = begin || 0;
        const endIndex = end || this.nElements;
        const result = new LinkedList();
        let currentNode = this.nodeAtIndex(startIndex);
        for (let i = startIndex; i < endIndex; ++i) {
            if (currentNode === null) {
                break;
            }
            result.add(currentNode.element);
            currentNode = currentNode.next;
        }
        return result;
    }
    [Symbol.iterator]() {
        let currentNode = this.firstNode;
        return {
            next() {
                const value = currentNode && currentNode.element;
                const done = currentNode === null;
                currentNode = currentNode !== null ? currentNode.next : null;
                return {
                    value,
                    done
                };
            }
        };
    }
    size() {
        return this.nElements;
    }
    get length() {
        return this.nElements;
    }
    isEmpty() {
        return this.nElements <= 0;
    }
    toString() {
        return `[${this.toArray().toString()}]`;
    }
    equalsAux(n1, n2, eqF) {
        while (n1 !== null) {
            if (n2 == null) {
                return false;
            }
            if (!eqF(n1.element, n2.element)) {
                return false;
            }
            n1 = n1.next;
            n2 = n2.next;
        }
        return true;
    }
    nodeAtIndex(index) {
        if (index < 0 || index >= this.nElements) {
            return null;
        }
        if (index === this.nElements - 1) {
            return this.lastNode;
        }
        let node = this.firstNode;
        for (let i = 0; i < index; i++) {
            node = (node && node.next) || null;
        }
        return node;
    }
    createNode(item) {
        return {
            element: item,
            next: null
        };
    }
}
export default LinkedList;
